export default {"src":"/_next/static/media/woman-thumbs-up.colour.f629005c.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};